export default Object.freeze({
  chatTypes: {
    group: 1,
    private: 4,
    special: 2,
    channel: 5
  },
  chatsPageSize: 20,
  // NB: EVEN NUMBERS ONLY!
  messagesPageSize: 50,
  maxMessageLength: 2048,
  activeChatMaxLimit: 500,
  messageTypes: {
    user: 1,
    chatCreated: 2,
    chatJoined: 3,
    chatLeft: 4
  },
  SERVICES_MENU: [
    {
      name: 'KickEx',
      short: 'ex',
      id: 3,
      status: 3,
      url: process.env.VUE_APP_KICKEX,
      // beta: true,
      visible: true
    },
    {
      name: 'KickRef',
      short: 'ref',
      id: 4,
      status: 3,
      url: process.env.VUE_APP_KICKREF,
      visible: true
    },
    {
      name: 'KickWallet',
      short: 'wallet',
      id: 5,
      status: 3,
      url: process.env.VUE_APP_WALLET,
      visible: true,
      alpha: false
    },
    {
      name: 'KickICO',
      short: 'ico',
      id: 1,
      status: 3,
      url: process.env.VUE_APP_KICKICO,
      visible: true
    },
    {
      name: 'KickMobile',
      short: 'mobile',
      id: null,
      status: 1,
      url: null,
      visible: true
    },
    {
      name: 'KickPAY',
      short: 'pay',
      id: 1,
      status: 1,
      url: null,
      visible: true
    },
    {
      name: 'KickCPA',
      short: 'cpa',
      id: 1,
      status: 1,
      url: null,
      visible: true
    },
    {
      name: 'KickDesk',
      short: 'desk',
      id: null,
      status: 1,
      url: null,
      visible: true
    }
  ]
});
